/**
 * Custom error class for authentication failures (HTTP 401).
 */
export class AuthenticationError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "AuthenticationError";
    }
}
